/**
 * Offer Cards — filtros interativos
 * Dropdown de categoria, busca por nome, abas.
 * Uma aba com data-mostra-docs="1" (ex: "Encerradas") esconde a grid e os
 * filtros de categoria/busca, exibindo em vez disso a seção apontada por
 * data-docs-target nas abas (ex: flux-docs).
 */
export function initOfferCards() {
  const wrapper = document.querySelector('.offer-cards');
  if (!wrapper) return;

  const cards = Array.from(wrapper.querySelectorAll('.offer-cards__card'));
  const gridEl = wrapper.querySelector('.offer-cards__grid');
  const emptyEl = wrapper.querySelector('.offer-cards__empty');
  const selectGroup = wrapper.querySelector('.offer-cards__filter-group--select');
  const buscaGroup = wrapper.querySelector('.offer-cards__filter-group--busca');
  const selectEl = wrapper.querySelector('.offer-cards__select[data-filter="categoria"]');
  const searchInput = wrapper.querySelector('.offer-cards__input[data-filter="busca"]');
  const abasContainer = wrapper.querySelector('.offer-cards__abas[data-filter="tipo"]');

  let activeCategoria = '';
  let searchTerm = '';

  // ── Estado vazio ("Nenhuma oferta disponível") ──
  // Exibe a mensagem quando nenhum card está visível, exceto quando a grid
  // está oculta (aba de documentos), onde a mensagem não faz sentido.
  function updateEmptyState() {
    if (!emptyEl) return;
    const anyVisible = cards.some(card => !card.hasAttribute('hidden'));
    emptyEl.hidden = anyVisible || Boolean(gridEl && gridEl.hidden);
  }

  // ── Filtrar cards (categoria + busca) ────────
  function filterCards() {
    cards.forEach(card => {
      const matchCat = !activeCategoria || card.dataset.categoria === activeCategoria;
      const matchSearch = !searchTerm || card.dataset.nome.includes(searchTerm);

      if (matchCat && matchSearch) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', '');
      }
    });
    updateEmptyState();
  }

  // ── Alterna entre grid de ofertas e seção de documentos ──
  // Os documentos ficam sempre visíveis; a aba só controla a grid/filtros.
  function setMostraDocs(mostraDocs) {
    if (gridEl) gridEl.hidden = mostraDocs;
    if (selectGroup) selectGroup.hidden = mostraDocs;
    if (buscaGroup) buscaGroup.hidden = mostraDocs;
    updateEmptyState();
  }

  // ── Dropdown (select fake) ──────────────────
  if (selectEl) {
    const textEl = selectEl.querySelector('.offer-cards__select-text');
    const dropdown = selectEl.querySelector('.offer-cards__dropdown');
    const items = selectEl.querySelectorAll('.offer-cards__dropdown-item');

    selectEl.addEventListener('click', (e) => {
      // Ignore clicks that originate from the dropdown list
      if (dropdown && dropdown.contains(e.target)) return;
      e.stopPropagation();
      selectEl.classList.toggle('is-open');
    });

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        items.forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');
        activeCategoria = item.dataset.value || '';
        textEl.textContent = item.textContent.trim();
        selectEl.classList.remove('is-open');
        filterCards();
      });
    });

    document.addEventListener('click', () => {
      selectEl.classList.remove('is-open');
    });
  }

  // ── Busca ────────────────────────────────────
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      searchTerm = searchInput.value.trim().toLowerCase();
      filterCards();
    });
  }

  // ── Abas ─────────────────────────────────────
  if (abasContainer) {
    const abas = abasContainer.querySelectorAll('.offer-cards__aba');
    abas.forEach(aba => {
      aba.addEventListener('click', () => {
        abas.forEach(a => a.classList.remove('is-active'));
        aba.classList.add('is-active');
        setMostraDocs(aba.dataset.mostraDocs === '1');
      });
    });

    // Inicializar com a primeira aba ativa
    const firstAba = abas[0];
    if (firstAba) {
      setMostraDocs(firstAba.dataset.mostraDocs === '1');
    }
  }

  filterCards();
}
